window.Products.Clothing.Peignoir = function() {
};
window.Products.Clothing.Peignoir.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.Peignoir.id = 70;
window.Products.Clothing.Peignoir.slug = 'peignoir';
window.Products.Clothing.Peignoir.has_3d = true;
window.Products.Clothing.Peignoir.dpi = 150;

window.Products.Clothing.Peignoir.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = 0.45;
	modelViewer.setFixedView('front');
};

window.Products.Clothing.Peignoir.prototype.setThreeControls = function(controls) {
	controls.minDistance = 17;
	controls.maxDistance = 21;
};

window.Products.Clothing.Peignoir.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material[3].transparent = true;
	modelViewer.object.children[0].material[3].opacity = 0.95;
	modelViewer.object.children[0].material[0].map = modelViewer.texture;
	modelViewer.object.children[0].material[1].map = modelViewer.texture;
};